export const idTypeRoutes = {
  A: '',
  U: 'users',
  D: 'deals',
  T: 'transactions',
  P: 'promised-payments',
  C: 'credit-cards',
  B: 'brokers',
  F: 'manage-facilities',
  FF: 'feature-flags',
  BA: '',
  BU: 'broker-users',
  PA: 'partner-agents',
  PU: 'partner-users',
  RU: 'report-users',
  CI: 'commission-issuers',
  CIU: '',
  DI: 'discounts',
  PP: 'pricing-policies',
  PT: '',
  PPR: 'pricing-policy-rules',
  ED: 'external-deal',
  EU: 'external-user',
  CDA: 'cda',
  PCDAD: 'partner-cda-deals',
  I: 'integrations',
  R: '',
};

export type IdTypeList = keyof typeof idTypeRoutes;
